import React, { useState } from 'react';

const Effectfaq = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="rbt-main-content mb-0">
      <div className="rbt-daynamic-page-content ">
        <div className="rbt-dashboard-content">
          <div className="banner-area">
            <div className="settings-area">
              <h3 className="title additional-help-class">Have Any Question?</h3>
            </div>
          </div>
          <div className="content-page pb--50">
            <div className="chat-box-list">
              <div className="content">
                <div className="rainbow-accordion-style accordion rainbow-section-gapBottom">
                  <div className="accordion" id="accordionExamplea">
                    {[ 
                      {
                        id: '1',
                        question: 'What is the Text-to-Sound effect and how does it work?',
                        answer: 'The Text-to-Sound effect converts written text into various sound effects or audio patterns, offering a creative way to interact with text-based content.',
                      },
                      {
                        id: '2',
                        question: 'Can I create sound effects from any kind of text?',
                        answer: 'Yes, you can create sound effects from any text including articles, stories, or instructions. The tool can transform textual content into ambient sounds or effects.',
                      },
                      {
                        id: '3',
                        question: 'How can I control the type of sound generated?',
                        answer: 'You can customize the sound generated by choosing different presets or by adjusting parameters like tone, pitch, and intensity for a personalized auditory experience.',
                      },
                      {
                        id: '4',
                        question: 'Are there different styles of sound effects available?',
                        answer: 'Yes, the tool provides multiple sound styles, from nature sounds to mechanical noises, and you can experiment with a variety of effects to suit your needs.',
                      },
                      {
                        id: '5',
                        question: 'Is the Text-to-Sound service secure?',
                        answer: 'Yes, we ensure that the generated sounds and any associated data are processed securely and in compliance with privacy policies.',
                      },
                      {
                        id: '6',
                        question: 'Can I integrate Text-to-Sound into my multimedia projects?',
                        answer: 'Absolutely! The Text-to-Sound service allows you to integrate sound effects into your videos, podcasts, or any other multimedia content, enhancing the sensory experience.',
                      },
                    ].map((item, index) => (
                      <div className="accordion-item card" key={item.id}>
                        <h2 className="accordion-header card-header" id={`heading${item.id}`}>
                          <button
                            className={`accordion-button ${openIndex === index ? '' : 'collapsed'}`}
                            type="button"
                            onClick={() => toggleAccordion(index)}
                            aria-expanded={openIndex === index}
                            aria-controls={`collapse${item.id}`}
                          >
                            {item.question}
                          </button>
                        </h2>
                        <div
                          id={`collapse${item.id}`}
                          className={`accordion-collapse collapse ${openIndex === index ? 'show' : ''}`}
                          aria-labelledby={`heading${item.id}`}
                          data-bs-parent="#accordionExamplea"
                        >
                          <div className="accordion-body card-body">
                            {item.answer}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Effectfaq;
